import {getToken, goToLink, removeUser} from './authService';

// const axios = require('axios').default;
import axios from 'axios';
import AuthModel from '../screens/Auth/Auth.model';
const FormData = require('form-data');
import call from './api';

interface API_PARAMS {
    path: string;
    method?: string;
    data?: any;
    kind?: string;
}


export const postCall = async (params: API_PARAMS, imageUpload?:boolean) => {
    const {path, method = 'GET', data = {}, kind = 'raw'} = params;

    let form;
    const token = getToken();
    const extraConfig: any = {
        headers: {}
    };
    if (token) {
        extraConfig.headers.Authorization = token;
    }
    if (method === 'POST'|| method === 'PUT') {
        if(kind === 'raw' ){
            form=data
        }else{
            form = new FormData();

            const dataKeys: any = Object.keys(data);
            for (const key of dataKeys) {
                if (data[key] !== undefined && data[key] !== null) {
                    form.append(key, data[key]);
                }
            }   
            extraConfig.headers['Content-Type'] = 'multipart/form-data';
        }
    
        // console.log(form);
        extraConfig.data = form;
    } else {
        extraConfig.params = data;
    }
    let url = `${imageUpload ? process.env.REACT_APP_UPLOAD_IMG_API_BASE_URL : process.env.REACT_APP_API_BASE_URL}${path}`;
    
   
    let response: any;
    try {
        response = await axios.post(url,form);
        if(response?.data?.error?.code == -32623){
            await refreshToken();
            const token = getToken();
            extraConfig.headers.Authorization
            params.data.cred.token = token
            response = await axios.post(url,form);
        }
        if(response?.data?.error?.code == -34122){
            goToLink(`/change-password`);
        }
        if(response?.data?.error?.code == -34152){
            removeUser();
            goToLink(`/login`);
        }
    } catch (e:any) {
        if (e.isAxiosError) {
            console.log(e);
            throw e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : e.message;
        }
        
        return e;
    }

    if ([200, 201].indexOf(response.status) === -1) {
        throw new Error(response.statusText).message;
    }
    
    return response.data;
};

const refreshToken = async () => {
    let result = null;
    try {
        result = await call(
            {
                path: '/refresh_token',
                method: 'POST',
                data: {
                    user: localStorage.getItem('user'),
                    token: localStorage.getItem('token'),
                    days: 14,
                }
            });
        if (result && result?.token) {
            await localStorage.setItem('token', result?.token)
        } else {
            console.log(result)
        }
    } catch (error: any) {
        console.log(error)
        return result?.error
    }
}
